import script from "./OurTeamSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./OurTeamSlider.vue?vue&type=script&setup=true&lang=js"

import "./OurTeamSlider.vue?vue&type=style&index=0&id=7885c40e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7885c40e"]])

export default __exports__